import { RoleOption } from '../components/forms/roles/types';

export const createRoleOption = (roleId: string): RoleOption => ({
  id: roleId,
  name: roleId,
});
